import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';

function NewIndustryLandingPage({ page: { MainContent, breadCrumbList } }) {
  const HeroComponent = React.lazy(() =>
    import('./new-industry-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-industry-content-component')
  );

  return (
    <div className="industries industries-lp">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent />
      </Suspense>
    </div>
  );
}

export default NewIndustryLandingPage;
